import React, { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import "../../common/commonStyles.css";
import { isSubFieldVisible } from "../../Settings/productFormSubFieldUtils";

const PiecePricingTable = ({
  formData,
  handleChange,
  handleBlur,
  errors,
  accessToken,
  visibleSubFields = null,
}) => {
  const showBand = (bandNumber) =>
    isSubFieldVisible(visibleSubFields, `band_${bandNumber}`);
  const showPricePiece = isSubFieldVisible(visibleSubFields, "price_piece");
  const showSpecialPiece =
    visibleSubFields != null
      ? visibleSubFields.special_price_piece === true
      : accessToken === "rhp";

  const bandConfig = useMemo(
    () =>
      [
        {
          bandNumber: 1,
          piecePriceField: "split_price",
          pieceSpecialPriceField: "band1_special_piece_price",
          piecePriceError: errors.split_price,
        },
        {
          bandNumber: 2,
          piecePriceField: "piece_price1",
          pieceSpecialPriceField: "band2_special_piece_price",
          piecePriceError: errors.piece_price1,
        },
        {
          bandNumber: 3,
          piecePriceField: "piece_price2",
          pieceSpecialPriceField: "band3_special_piece_price",
          piecePriceError: errors.piece_price2,
        },
        {
          bandNumber: 4,
          piecePriceField: "piece_price3",
          pieceSpecialPriceField: "band4_special_piece_price",
          piecePriceError: errors.piece_price3,
        },
        {
          bandNumber: 5,
          piecePriceField: "piece_price4",
          pieceSpecialPriceField: "band5_special_piece_price",
          piecePriceError: errors.piece_price4,
        },
        {
          bandNumber: 6,
          piecePriceField: "piece_price5",
          pieceSpecialPriceField: "band6_special_piece_price",
          piecePriceError: errors.piece_price5,
        },
      ].filter((band) => showBand(band.bandNumber)),
    [errors, visibleSubFields],
  );

  const showSpecialPieceColumn = showSpecialPiece;

  if (!bandConfig.length || (!showPricePiece && !showSpecialPieceColumn)) {
    return null;
  }

  return (
    <TableContainer>
      <Table size="small" className="table-cell-border">
        <TableHead className="table-cell-header">
          <TableRow sx={{ bgcolor: "#f4f6f8" }}>
            <TableCell
              sx={{ color: "#637387", fontWeight: 600, fontSize: 12, width: "33%" }}
            >
              {accessToken === "rhp" ? "Band" : "Price"}
            </TableCell>
            {showPricePiece && (
              <TableCell
                sx={{
                  color: "#637387",
                  fontWeight: 600,
                  fontSize: 12,
                  width: "33%",
                }}
              >
                Price (Piece) <span style={{ color: "red" }}>*</span>
              </TableCell>
            )}
            {showSpecialPieceColumn && (
              <TableCell
                sx={{
                  color: "#637387",
                  fontWeight: 600,
                  fontSize: 12,
                  width: "34%",
                }}
              >
                Special Price (Piece)
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {bandConfig.map((band) => (
            <TableRow
              key={band.bandNumber}
              sx={{ "&:hover": { bgcolor: "rgba(145, 158, 171, 0.08)" } }}
            >
              <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>
                {accessToken === "rhp"
                  ? `Price ${band.bandNumber}`
                  : `Price ${band.bandNumber}`}
              </TableCell>
              {showPricePiece && (
                <TableCell sx={{ p: 1 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    type="number"
                    name={band.piecePriceField}
                    value={formData[band.piecePriceField] || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onWheel={(e) => e.target.blur()}
                    error={!!band.piecePriceError}
                    sx={{ "& .MuiInputBase-input": { fontSize: 12 } }}
                  />
                </TableCell>
              )}
              {showSpecialPieceColumn && (
                <TableCell sx={{ p: 1 }}>
                  <TextField
                    className="form-input-border"
                    fullWidth
                    size="small"
                    type="number"
                    name={band.pieceSpecialPriceField}
                    value={formData[band.pieceSpecialPriceField] || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onWheel={(e) => e.target.blur()}
                    sx={{ "& .MuiInputBase-input": { fontSize: 12 } }}
                  />
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PiecePricingTable;
